import { toPrecisionCeil } from '@openeducation/pp-js-utils';
import { PaymentMethod } from '@openeducation/pp-rn-shared-types';

export interface CalculateInstallmentsAmountsParams {
  paymentMethod: PaymentMethod;
  totalAmount: number;
  card1Amount?: string;
}

export const calculateInstallmentsAmounts = ({
  paymentMethod,
  totalAmount,
  card1Amount = '',
}: CalculateInstallmentsAmountsParams) => {
  const isTwoCreditCards = paymentMethod === PaymentMethod.TWO_CREDIT_CARDS;

  const card1AmountForInstallments = isTwoCreditCards
    ? parseFloat(card1Amount) || 0
    : totalAmount;

  const remaining = totalAmount - card1AmountForInstallments;
  const card2AmountForInstallments = isTwoCreditCards
    ? remaining > 0
      ? parseFloat(toPrecisionCeil(remaining))
      : 0
    : 0;

  return {
    card1AmountForInstallments,
    card2AmountForInstallments,
  };
};
